module.exports = __webpack_public_path__ + "assets/htu-7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HTU-modal/htu-7.jpg
// module id = 1194
// module chunks = 7